
import moment from "moment-timezone";

export default [
    {
        "tripId": 300500,
        "status": "Paid",
        "destination": "Delhi",
        "source": "Delhi",
        "goodPrice": "799,00",
        "issueDate": moment().subtract(1, "days").format("DD MMM YYYY"),
        "deliveryDate": moment().subtract(1, "days").add(1, "month").format("DD MMM YYYY")
    }
]